module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable"
  }, [_c('table', [_c('TableHeader', {
    attrs: {
      "title": _vm.title,
      "columns": _vm.Columns
    },
    on: {
      "toggleOrder": _vm.toggleOrder
    }
  }), _c('TableBody', {
    attrs: {
      "columns": _vm.Columns,
      "rows": _vm.Rows
    }
  }), _c('TableFooter', {
    attrs: {
      "columns": _vm.Columns,
      "rows": _vm.Rows
    }
  })], 1), _c('TablePagination', {
    attrs: {
      "page": _vm.page,
      "totalPages": _vm.totalPages
    },
    on: {
      "setPage": _vm.setPage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2f49e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ansergy-datatable/index.vue
// module id = 277
// module chunks = 1